import { Sale } from 'types/pricing';

// export const blackFridaySale = { annual: { coupon: 'WXA_FP50', discount: 0.5 } } as Sale; // Switch ON
export const blackFridaySale = {} as Sale; // Switch OFF
